<router-outlet></router-outlet>

<!-- <div class="footer">
  Powered by DCT <a href="http://www.dct.construction" target="_blank">www.dct.construction</a>
</div> -->